import AUApi from "./api";
import { Globals } from "./Globals";

// -- Globalisation  ---------------------------------------
// see https://ej2.syncfusion.com/vue/documentation/daterangepicker/globalization/?no-cache=1

// // declare var loadCldr: any;

// new ES/TS Typescript import for json data (see: https://hackernoon.com/import-json-into-typescript-8d465beded79)
// import gregorian from '@syncfusion/ej2-cldr-data/main/de/ca-gregorian.json';
// import numbers from '@syncfusion/ej2-cldr-data/main/de/numbers.json';
// import timeZoneNames from '@syncfusion/ej2-cldr-data/main/de/timeZoneNames.json';
// import numberingSystems from '@syncfusion/ej2-cldr-data/supplemental/numberingSystems.json';
// import localNumbers from "cldr-data//main/de/numbers.json";
// import currencies from "cldr-data/main/de/currencies.json";
// import localCalender from "cldr-data/main/de/ca-gregorian.json";
// import localTimeZoneNames from "cldr-data/main/de/timeZoneNames.json";
// load the locale object to set the localized placeholder value
// sollte hier Datei Local_AT verwenden
//import { localSettings } from "./localisation/localisationSettings";
// import numberingSystems from "cldr-data/main/de/numberingSystems.json';

let api: AUApi;

export function initLocalisation() {
  api = AUApi.Current;
  //   // setCurrencyCode("EUR");
  //  setCulture("de");
  //   loadCldr(localNumbers, localCalender, localTimeZoneNames, currencies);
  //   L10n.load(localSettings);
}

function findIt(kennung: string, list: any[]) {
  if (!kennung) {
    return kennung;
  }
  kennung = kennung.toLowerCase();
  if (!api || !list) {
    return null;
  }
  const item = list.find(
    (f: any) =>
      (f.kennung && f.kennung.toLowerCase() === kennung) ||
      (f.Kennung && f.Kennung.toLowerCase() === kennung)
  );
  return item;
}
function findId(aic: number, list: any[]) {
  if (!api || !list) {
    return null;
  }
  const item = list.find((f: any) => f.aic === aic);
  return item;
}
function findStt(stt: number, list: any[]) {
  if (!api || !list) {
    return null;
  }
  const item = list.find((f: any) => (f.stt === stt || f.aic === stt));
  return item;
}
function findSttKennung(stt: string, list: any[]) {
  if (!api || !list) {
    return null;
  }
  const item = list.find((f: any) => f.kennung === stt);
  return item;
}
function findAmpel(ampel: number, list: any[]) {
  if (!api || !list) {
    return null;
  }
  const item = list.find((f: any) => f.system === ampel);
  return item;
}
function findGruppe(gruppe: string, list: any[]) {
  if (!api || !list) {
    return null;
  }
  const item: any = [];
  if (list.length > 0) {
    const li = list;
    for (let j = 0; j < li.length; j++) {
      const c = li[j];
      if (c.gruppe === gruppe) {
        item.push(c);
      }
    }
    return item;
  }
}
// function findSttAic(stt: string, list: any[]) {
//   if (!api || !list) {
//     return null;
//   }
//   const item = list.find((f: any) => f.system === stt);
//   return item;
// }

// 4. add an instance method
// sucht in der Begriffstabelle nach der Kennung und gibt Bezeichnung zurück
// wenn eine vorhanden ist
export function begriffBezeichnung(kennung: string, fallback = "") {
  if (api) {
    const x: any = findIt(kennung, api.Begriff);
    if (x) {
      return x.bezeichnung;
    }
  }
  console.warn(
    "begriffBezeichnung kann keinen Begriff zum kennung '" +
    kennung +
    "' finden (oder Begriffe sind nicht initialisiert) !"
  );
  return fallback ?? kennung;
}
export function begriffCode(kennung: string) {
  if (api) {
    const x: any = findIt(kennung, api.Begriff);
    if (x) {
      return x.bezeichnung;
    }
  }
  console.warn(
    "$begriffCode kann keinen Begriff zum aic '" +
    kennung +
    "' finden (oder Begriffe sind nicht initialisiert) !"
  );
  return kennung;
}

export function globalsBegriffCache(
  type: Globals,
  kennung: string,
  alt?: string
): string {
  const x = globalsKennung(type, kennung, false);
  if (x) {
    return x.SbRefresh as string;
  }
  if (!alt) {
    return "null";
  }
  return alt;
}

export function begriffTooltip(kennung: string) {
  if (api) {
    const x: any = findIt(kennung, api.Begriff);
    if (x) {
      return x.tooltip;
    }
  }
  console.warn(
    "$begriffTooltip kann keinen Begriff zum aic '" +
    kennung +
    "' finden (oder Begriffe sind nicht initialisiert) !"
  );
  return kennung;
}

export function begriffAic(aic: number) {
  if (api) {
    const x: any = findId(aic, api.Begriff);
    if (x) {
      return x;
    }
  }
  console.warn(
    "$begriffAic kann keinen Begriff zum aic '" +
    aic +
    "' finden (oder Begriffe sind nicht initialisiert) !"
  );
  return aic;
}
export function globalsModellFarbe(
  type: Globals,
  kennung: string,
  alt: string | null = null
) {
  const x = globalsKennung(type, kennung, false);
  if (x && x.farbe) {
    return x.farbe;
  }
  if (!alt) {
    return kennung;
  }
  return alt;
};
export function globalsKennung(type: Globals, kennung: string, warn: boolean = true) {
  if (api) {
    const list = getListfromType(type);
    const x: any = findIt(kennung, list);
    if (x) {
      return x;
    }
  }
  if (warn) {
    let typeStr = "???";
    switch (type) {
      case 0:
        typeStr = "Begriff";
        break;
      case 1:
        typeStr = "Einheit";
        break;
      case 2:
        typeStr = "Code";
        break;
      case 3:
        typeStr = "Mandanten";
        break;
      case 4:
        typeStr = "Stt";
        break;
      case 6:
        typeStr = "Ampel";
        break;
      case 7:
        typeStr = "Node";
        break;
    }
    console.warn(
      "$globalsKennung kann keinen '" +
      typeStr +
      "' zur kennung '" +
      kennung +
      "' finden (oder Begriffe sind nicht initialisiert) !"
    );
  }
  return null;
}

export function globalsAic(type: Globals, aic: number) {
  if (aic === undefined) {
    console.warn(
      "aic wurde an globalsAic nicht übergeben"
    );
    return;
  }
  if (api) {
    const list = getListfromType(type);
    const x: any = findId(aic, list);
    if (x) {
      return x;
    }
  }
  console.warn(
    "$begriffAic kann keinen '" +
    type +
    "' zum aic '" +
    aic +
    "' finden (oder Begriffe sind nicht initialisiert) !"
  );
  return aic;
}
// Systemabfrage für Stammtyp finden
export function globalsStt(type: Globals, stt?: number, kennung?: string, noFilter?: boolean) {

  if (api) {
    let list = getListfromType(type);
    if (noFilter) {
      list = list.filter(x => !x.filter);
    }
    if (stt) {
      list = list.filter((y: any) => (y.system === true));
      const x: any = findStt(stt, list);
      if (x) {
        return x;
      }
    } else if (kennung) {
      const x: any = findSttKennung(kennung, list);
      if (x) {
        return x;
      }
    }
  }
  console.warn(
    "$begriffStt kann keinen '" +
    type +
    "' zum Stammtyp '" +
    stt +
    "' finden (oder Begriffe sind nicht initialisiert) !"
  );
  return null;
}
export function globalsFrame(type: Globals, pers: boolean, stammtyp?: any, name?: string,
  standard?: boolean, kennung?: string) {
  if (api) {
    const list = api.Begriff;
    if (list.length > 0) {
      let x: any = findGruppe("Frame", list);
      if (pers) {
        const item: any = [];
        for (let j = 0; j < x.length; j++) {
          const c = x[j];
          if (c.pers === true) {
            if (stammtyp && c.stt === stammtyp.aic) {
              item.push(c);
            } else if (!stammtyp) {
              item.push(c);
            }
          }
        }
        x = item;
      } else if (name) {
        const item: any = [];
        for (let j = 0; j < x.length; j++) {
          const c = x[j];
          if (c.bezeichnung === name) {
            item.push(c);
          }
        }
        x = item;
      } else if (kennung) {
        const item: any = [];
        for (let j = 0; j < x.length; j++) {
          const c = x[j];
          if (c.kennung === kennung || c.alias === kennung) {
            item.push(c);
          }
        }
        x = item;
      } else if (stammtyp) {
        const item: any = [];
        for (let j = 0; j < x.length; j++) {
          // const c = x[j];
          if (x[j].stt && x[j].stt === stammtyp.aic) {
            if (standard) {
              if (x[j].standard) {
                item.push(x[j]);
              }
            } else {
              item.push(x[j]);
            }
          } else if (!stammtyp) {
            item.push(x[j]);
          }
        }
        x = item;
      }
      return x;
    }
  }
  console.warn("$begriffFrame kann keinen '" + type + "' zum Frame finden'");
  return null;
}
export function globalsDruck(type: Globals, pers: boolean, stammtyp: any, aic?: boolean, aicDruck?: number) {
  if (api) {
    const list = api.Begriff;
    if (list.length > 0) {
      let x: any = findGruppe("Druck", list);
      if (aicDruck) {
        const item: any = [];
        for (let j = 0; j < x.length; j++) {
          const c = x[j];
          if (c.aic === aicDruck) {
            item.push(c);
          }
        }
        x = item;
      } else if (pers) {
        const item: any = [];
        for (let j = 0; j < x.length; j++) {
          const c = x[j];
          if (c.pers === true) {
            if (stammtyp && c.stt === stammtyp.aic) {
              item.push(c);
            } else if (!stammtyp) {
              item.push(c);
            }
          }
        }
        x = item;
      } else {
        const item: any = [];
        for (let j = 0; j < x.length; j++) {
          const c = x[j];
          if (aic) {
            if (stammtyp && c.stt === stammtyp) {
              item.push(c);
            }

          } else if (!aic) {
            if (stammtyp && c.stt === stammtyp.aic) {
              item.push(c);
            }
          }
        }
        x = item;
      }
      return x;
    }
  }
  console.warn("$begriffDruck kann keinen '" + type + "' zum Druck finden'");
  return null;
}
export function globalsLayout(type: Globals) {
  if (api) {
    const list = api.Begriff;
    if (list.length > 0) {
      const x: any = findGruppe("Layout", list);
      return x;
    }
  }
  console.warn("$begriffLayout kann keinen '" + type + "' zum Layout finden'");
  return null;
}
export function globalsAmpel(type: Globals, aic: number) {
  if (api) {
    const list = api.Ampel;
    const x: any = findId(aic, list);
    // in x steht bezeichnung, nr und aic
    return x;
  }
  console.warn("$begriffAmpel kann keinen '" + type + "' zur Ampel finden'");
  return null;
}
export function globalsAufgaben(pers: boolean) {
  if (api) {
    const list = api.Begriff;
    if (list.length > 0) {
      let x: any = findGruppe("Aufgabe", list);
      if (pers) {
        const item: any = [];
        for (let j = 0; j < x.length; j++) {
          const c = x[j];
          if (c.pers === true) {
            item.push(c);
          }
        }
        x = item;
      } else {
        const item: any = [];
        for (let j = 0; j < x.length; j++) {
          const c = x[j];
          if (c.pers !== true) {
            item.push(c);
          }
        }
        x = item;
      }
      return x;
    }

  }
  console.warn("$begriffAufgabe keine Aufgabe finden'");
  return null;
}
function getListfromType(type: Globals) {
  if (!api) {
    throw new Error("API not initialized!!!");
  }
  let list: AllDescribedEntityWithKennung[] = api.Begriff;
  if (type === Globals.Einheit) {
    list = api.Einheiten;
    // } else if (type === Globals.Eigenschaft) {
    //   list = api.Eigenschaft;
  } else if (type === Globals.Code) {
    list = api.Code;
  } else if (type === Globals.Mandanten) {
    list = api.Mandanten;
  } else if (type === Globals.Stt) {
    list = api.Stt;
    // Tabellen vereinheitlicht...
    // } else if (type === Globals.Security) {
    //   list = api.Security;
    // } else if (type === Globals.SysAbfrage) {
    //   list = api.SysAbfrage;
  }
  return list;
}


export function globalsBezeichnung(
  type: Globals,
  kennung: string,
  alt?: string
): string {
  const x = globalsKennung(type, kennung, false);
  if (x && x.bezeichnung) {
    return x.bezeichnung;
  }
  if (!alt) {
    return kennung;
  }
  return alt;
}

export function getLocalisationFunctions(newapi: AUApi = AUApi.Current) {
  api = newapi;
  return {
    globalsBezeichnung
  };
}

export function globalsBegriffMemo(
  type: Globals,
  kennung: string,
  alt: string | null = null
): string {
  const x = globalsKennung(type, kennung, false);
  if (x?.memo) {
    return x.memo;
  }
  if (!alt) {
    return x.bezeichnung;
  }
  return alt;
}
export function globalsBegriffMobile(
  type: Globals,
  kennung: string,
  alt: string | null = null
): string {
  const x = globalsKennung(type, kennung, false);
  if (x) {
    return x.alias;
  }
  if (!alt) {
    return "null";
  }
  return alt;
}


export function checkBegriff(kennung: string) {
  const x = globalsKennung(Globals.Begriff, kennung, false);
  return x;
}
export function checkNode(kennung: string) {
  const x = globalsKennung(Globals.Node, kennung, false);
  return x;
}
export function checkMobile(kennung: string) {
  const x = globalsBegriffMobile(Globals.Begriff, kennung, "");
  return x;
}